export default "<span class=\"alert errorDiv\" role=\"alert\" *ngIf=\"mostrarErro\">\n  <i class=\"icofont-warning-alt\"></i>{{ msgErro }}\n</span>\n"